import React from 'react'
import { SvgIcon } from '@mui/material'

export function NotificationsOffIcon() {
  return (
    <SvgIcon
      viewBox="0 0 64 64"
      sx={{ color: 'error.main', width: '64px', height: '64px' }}
    >
      <g clipPath="url(#CameraOffIconUrl)">
        <path
          fill="#E6494F"
          d="M32 58.666c2.933 0 5.333-2.4 5.333-5.333H26.667c0 2.934 2.4 5.334 5.333 5.334Zm0-41.333c6.64 0 10.667 5.387 10.667 12v.267L48 34.933v-5.6c0-8.186-4.347-15.04-12-16.853v-1.814c0-2.213-1.787-4-4-4s-4 1.787-4 4v1.814c-.64.16-1.253.4-1.84.613l4.373 4.373c.48-.053.96-.133 1.467-.133Zm-17.573-8.4-3.76 3.76 7.493 7.493C16.773 22.853 16 25.973 16 29.334v13.334L10.667 48v2.666H48.64l4.64 4.64 3.76-3.76L14.427 8.934Zm28.24 36.4H21.333v-16c0-1.813.32-3.52.907-5.066l20.427 20.426v.64Z"
        />
      </g>
      <defs>
        <clipPath id="CameraOffIconUrl">
          <path fill="#fff" d="M0 0h64v64H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
